// extracted by css-extract-rspack-plugin
export default {"cls1":"ZeroState-cls1_cCo","cls2":"ZeroState-cls2_YsB ZeroState-cls1_cCo","isMobile":"ZeroState-isMobile_0XP"};